import React, { useCallback, JSX } from 'react';
import { IKeyword, MpKeywordSettings } from 'src/models/matchingProfiles/types';
import { useUpdateMPKeyword, useLoadMp, usePrefixSearchLimit } from 'src/models/matchingProfiles/hooks';
import PlainDropDown from 'src/common/PlainDropDown';
import { IPlainDropdownValue } from 'src/common/PlainDropDown/types';
import { SearchLogic } from '@tendium/prom-types';

interface IProps<T extends string> {
  label: string;
  selectedValue: T;
  values: IPlainDropdownValue<T>[];
  disabled?: boolean;
  keyword: IKeyword;
  field: keyof MpKeywordSettings;
  className?: string;
}

export function SelectField<T extends string>(props: IProps<T>): JSX.Element {
  const { values, selectedValue, label, keyword, field, disabled, className } = props;
  const prefixSearchLimit = usePrefixSearchLimit();
  const { data: mp } = useLoadMp();
  const mpId = mp?.id;
  const keywords = mp?.keywords;

  const [updateKeyword, { loading: updateLoading }] = useUpdateMPKeyword();
  const onUpdate = useCallback(
    (val: T) => {
      const isPrefixSearchLimit =
        !!keywords &&
        keywords.filter(kwd => kwd.searchLogic === SearchLogic.PrefixMatch).length >= prefixSearchLimit &&
        field === 'searchLogic' &&
        val === SearchLogic.PrefixMatch;
      !isPrefixSearchLimit && mpId && updateKeyword({ ...keyword, [field]: val });
    },
    [field, keyword, keywords, mpId, updateKeyword, prefixSearchLimit]
  );
  return (
    <PlainDropDown
      values={values}
      selectedValue={selectedValue}
      label={label}
      onSelect={onUpdate}
      hideLabel
      disabled={disabled}
      className={className}
      loading={updateLoading}
      type="single"
    />
  );
}

export default SelectField;
